import { put, takeEvery } from 'redux-saga/effects';
import {
  fetchStatisticsSuccess,
  fetchStatisticsFailure,
} from 'redux/ums-user-management/actions';
import { Notify } from '@flexisaf/flexibull2';
import request from 'utils/request';
import urls from 'utils/config';
import UmsUserManagementActionTypes from '../types';
import { ERROR, TOP_RIGHT } from 'utils/constants';

const { API_BASE_URL } = urls || {};

export function* fetchStatistics() {
  const url = `${API_BASE_URL}/ums/statistics/users`;

  const response = yield request({
    method: 'get',
    url,
  });

  if (response.success) {
    yield put(fetchStatisticsSuccess(response.raw));
  } else {
    Notify(`Failed to Fetch Statistics: ${response.message}`, {
      position: TOP_RIGHT,
      status: ERROR,
    });
    yield put(fetchStatisticsFailure(response.message));
  }
}

export function* onFetchfetchStatistics() {
  yield takeEvery(
    UmsUserManagementActionTypes.FETCH_USER_STATISTICS_START,
    fetchStatistics
  );
}
